import { getSessionId } from './session-storage';

const resolveApiUrl = () => {
  if (typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;
    if (protocol === 'https:' && hostname.startsWith('web-')) {
      return `https://api-${hostname.slice(4)}`;
    }
  }

  return process.env.REACT_APP_API_BASE_URL?.trim() || '';
};

export const apiUrl = resolveApiUrl();

const valueForQuery = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return value;
};

const createUrl = (address, queryParams = {}) => {
  const baseUrl = apiUrl?.replace(/\/$/, '');
  const normalizedAddress = String(address).replace(/^\//, '');
  const url = new URL(`${baseUrl}/${normalizedAddress}`);

  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    if (Array.isArray(value)) {
      value.forEach((item) => url.searchParams.append(key, valueForQuery(item)));
      return;
    }

    url.searchParams.append(key, valueForQuery(value));
  });

  return url;
};

const parseResponse = async (response, options) => {
  if (response.ok && response.status === 204) {
    return undefined;
  }

  const contentType = response.headers.get('content-type') || '';

  if (!response.ok || options.rawResponse) {
    const text = await response.text();
    if (!text) {
      return {
        status: response.status,
        message: response.statusText,
      };
    }

    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }

  if (options.download || options.blob) {
    return response.blob();
  }

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
};

export const serverFetch = async (address, options = {}) => {
  const url = createUrl(address, options.queryParams);
  const headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  });

  const sessionId = getSessionId();
  if (sessionId) {
    headers.append('SessionId', sessionId);
  }

  if (options.headers) {
    Object.keys(options.headers).forEach((key) => {
      headers.set(key, options.headers[key]);
    });
  }

  const init = {
    method: 'GET',
    ...options,
    headers,
  };

  delete init.queryParams;
  delete init.bodyData;
  delete init.rawResponse;
  delete init.download;
  delete init.blob;

  if (options.bodyData !== undefined) {
    init.body = JSON.stringify(options.bodyData);
  }

  let response;
  try {
    response = await fetch(url, init);
  } catch {
    throw new Error('Не удалось подключиться к API.');
  }

  let content;
  try {
    content = await parseResponse(response, options);
  } catch {
    throw new Error('Ошибка обработки ответа API.');
  }

  if (response.ok) {
    return content;
  }

  if (typeof content === 'string') {
    throw new Error(content || response.statusText);
  }

  throw content || new Error(response.statusText);
};

export const getApiErrorMessage = (error) => {
  if (!error) {
    return 'Неизвестная ошибка.';
  }

  if (typeof error === 'string') {
    return error;
  }

  return error.userMessage || error.message || error.statusText || 'Неизвестная ошибка.';
};
